import { ICountry } from './country.interface';

export interface ICountries extends Map<string, ICountry> {}
